import React from "react";

import Modal from "../Modal";
import { Title } from "../Form";
import Tabs from "../Tabs";

import { Content, VideoFrame } from "./styles";
import { IProps } from "./interfaces";
import YouTube from "react-youtube";

export { default as Button } from "./Button";

const Tutorial = ({ audioplay, close, children, title, videoId }: IProps) => {
    return (
        <Modal close={close} width="616px" overflowHidden>
            <Title>{title}</Title>
            {videoId && (
                <VideoFrame>
                    <YouTube
                        videoId={videoId}
                        opts={{
                            playerVars: {
                                showinfo: 0,
                                controls: 1,
                                autoplay: audioplay ? 1 : 0,
                            },
                        }}
                    />
                </VideoFrame>
            )}
            <Content>
                <Tabs>{children}</Tabs>
            </Content>
        </Modal>
    );
}

export default Tutorial;
